module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "preview"
  }, [_vm._v("\n" + _vm._s(_vm.text) + "\n")])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-206dc39d"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/SelectionPreview.vue
// module id = 93
// module chunks = 2